<div class="container">
  <div class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-danger text-center font-weight-bold">{{message}}</div>
          @if(showAnticipationLnk){
          <div class="d-grid gap-2 col-6 mx-auto mt-2">
            <span class="text-success"> Vous pouvez payer la facture à l'avance en cliquant <a
                routerLink="/cashier/school/payment/anticipation/{{idStudent}}"
                class="text-decoration-underline" data-bs-dismiss="modal">ici</a></span>
          </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-3">
    <h3 class="text-center fw-bold col-sm-8">Paiement scolarité</h3>
  </div>

  @if (isBill) {
  <div id="bill-page" class="payment-page mt-3">
    <form [formGroup]="formBill">
      
      <div class="row justify-content-center">
        <div class="col-sm-6 form-group form-floating mb-3">
          <input type="text" class="form-control mt-2" placeholder="Entrer le code l'élève"
            formControlName="idStudent" id="idStudent">
          <label for="idStudent">Entrer le code compta de l'élève</label>
        </div>
      </div>
      <div class="d-grid gap-2 col-sm-3 mx-auto mt-2">
        <button class="btn btn-success" (click)="findBill()" [disabled]="!formBill.valid">Chercher</button>
      </div>
    </form>
  </div>
  }

  @if (isPayment) {
  <div id="payment-page" class="payment-page">
    @if(bills.length>1){
    <div class="mb-3">
      <div for="billSelect" class="form-label">Plusieurs factures trouvées, veuillez choisir celle à payer</div>
      @for (b of bills; track b) {
      <input value="{{b.id}}" class="me-3" type="radio" name="billSelect" (click)="onSelectBill(b)" /><span
        [ngClass]="bill.id ==b.id? 'bg-success text-white rounded p-3' : ''">{{b.studentName}} - {{b.amount}}
        {{b.currency?.currencyCode}} <br /></span>
      }
    </div>
    }
    @if(selectedBill){
    <div class="row justify-content-center">
      <div class="col-sm-8">
        
        <div class="mb-3">
          <label class="form-label">Nom de l'élève: <span class="fw-bold">{{bill.studentName}}</span></label>
        </div>
        <div class="mb-3">
          <label class="form-label">Montant :<span class="fw-bold">{{bill.amount}}
              {{bill.currency?.currencyCode}}</span></label>
        </div>
        @if(fees>0){
        <div class="mb-3">
          <label class="form-label">Frais de service :<span class="fw-bold">{{fees}}
              {{bill.currency?.currencyCode}}</span></label>
        </div>
        }
        @if(taxe>0){
        <div class="mb-3">
          <label class="form-label">Taxe :<span class="fw-bold">{{taxe}}
              {{bill.currency?.currencyCode}}</span></label>
        </div>
        }
      </div>
    </div>
    <div class="payment-header">
      <p>Veuillez choisir le moyen de paiement</p>
      <p>Et Renseigner le numero de téléphone du payeur</p>
    </div>
    <div class="row justify-content-center gap-method">
      <!--div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2"
        style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
        <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
        <p class="mt-2 mb-0 text-center">Carte</p>
      </div>
      <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2"
        style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
        <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
        <p class="mt-1 ml-3">Orange money</p>
      </div>
      <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
        data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
        <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
        <p class="mt-1  ml-3">Wave</p>
      </div-->
      @for(p of paymentMeans; track $index){
         <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
        [attr.data-method]="p.code" style="width: auto;" (click)="onSelectPaymentMethod(p)">
        <img class="mt-4 img-fluid justify-content-center" src="{{p.logo}}" alt="{{p.label}}" width="50">
        <p class="mt-1  ml-3">{{p.label}}</p>
      </div>
      }
    </div>
    }
    <form [formGroup]="formPay">
      <div class="row justify-content-center">
        <div class="form form-group col-sm-5 mb-2">
          @if (isWallet) {
          <input type="tel" placeholder="Numero t&#233;l&#233;phone du payeur" class="form-control" formControlName="phone">
          }
        </div>
      </div>
    </form>
    @if (isValid()&&!processing) {
    <div class="d-grid gap-2 col-sm-3 mx-auto">
      <button class="btn btn-primary" (click)="processPayment()">
        Valider</button>
    </div>
    }
  </div>
  }

  @if (qrCode.length>0) {
  <div class="row justify-content-center">
    <div class="d-flex justify-content-center">Scannez et payez </div>
    <div class="d-flex justify-content-center">
      <div class="d-block">
        <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
  </div>
  }
</div>
